import { render, staticRenderFns } from "./SmsLog.vue?vue&type=template&id=704de1e4&"
import script from "./SmsLog.vue?vue&type=script&lang=js&"
export * from "./SmsLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports